(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/iam-idp/assets/javascripts/react/components/shared/loading.js') >= 0) return;  svs.modules.push('/modules/iam-idp/assets/javascripts/react/components/shared/loading.js');

'use strict';

const {
  Loader
} = svs.components.ReactLoader;
const {
  isPnp
} = svs.iam_idp.data;
const Loading = () => React.createElement("div", {
  className: "login-loader-container"
}, React.createElement("p", {
  className: "margin-bottom-2"
}, "Loggar in..."), React.createElement(Loader, {
  inverted: !isPnp
}));
svs.iam_idp.components.shared.Loading = Loading;

 })(window);